const RECORD_PRODUCER_PREFILL_PARAM = "prefill";

const encodeBase64Url = (input: string) => {
    const bytes = new TextEncoder().encode(input);
    let binary = "";

    bytes.forEach((byte) => {
        binary += String.fromCharCode(byte);
    });

    return btoa(binary)
        .replace(/\+/g, "-")
        .replace(/\//g, "_")
        .replace(/=+$/g, "");
};

const decodeBase64Url = (input: string) => {
    const normalized = input
        .replace(/-/g, "+")
        .replace(/_/g, "/")
        .padEnd(Math.ceil(input.length / 4) * 4, "=");

    const binary = atob(normalized);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));

    return new TextDecoder().decode(bytes);
};

export const getRecordProducerPrefillParamKey = () => RECORD_PRODUCER_PREFILL_PARAM;

export const serializeRecordProducerPrefill = (value: Record<string, unknown>) =>
    encodeBase64Url(JSON.stringify(value));

export const deserializeRecordProducerPrefill = (value: string | null): Record<string, unknown> => {
    if (!value) {
        return {};
    }

    try {
        const parsed = JSON.parse(decodeBase64Url(value));
        return parsed && typeof parsed === "object" ? parsed : {};
    } catch (error) {
        console.warn("[RecordProducerPrefill] Failed to decode prefill", error);
        return {};
    }
};
